var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tarjeta"},[_c('div',{staticClass:"cabecera",class:_vm.tipo},[_vm._v(" "+_vm._s(_vm.titulo)+" ")]),_c('div',{staticClass:"cuerpo"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }